import { defineMessages } from 'react-intl';

export default defineMessages({
	isFavedAnnouncement: {
		id: 'programFaveHeart.isFavedAnnouncement',
		defaultMessage: '{title} added to favorites',
		description: 'Notification to screen reader that a user has favorited a program',
	},
	isUnfavedAnnouncement: {
		id: 'programFaveHeart.isUnfavedAnnouncement',
		defaultMessage: '{title} removed from favorites',
		description: 'Notification to screen reader that a user has unfavorited a program',
	},
	faveAriaLabel: {
		id: 'programFaveHeart.faveAriaLabel',
		defaultMessage: 'mark as favorite',
		description: 'Accessible label for the button that favorites a program',
	},
	unfaveAriaLabel: {
		id: 'programFaveHeart.unfaveAriaLabel',
		defaultMessage: 'unmark as favorite',
		description: 'Accessible label for the button that removes a program from favorites',
	},
});
